import { fetchCurrentUser } from '../../ducks/user.duck';
import { deleteRulebookApi, deleteRuleBookFile, fetchSpaceListApiV2, getAllRulebooks, getSpecificUserGPTS } from '../../util/api';
import axios from 'axios';

// ================ Action types ================ //

export const FETCH_SPACE_LIST_REQUEST = 'app/AdminPanelSupabasePage/FETCH_SPACE_LIST_REQUEST';
export const FETCH_SPACE_LIST_SUCCESS = 'app/AdminPanelSupabasePage/FETCH_SPACE_LIST_SUCCESS';
export const FETCH_SPACE_LIST_ERROR = 'app/AdminPanelSupabasePage/FETCH_SPACE_LIST_ERROR';
export const OPEN_EDIT_MODAL = 'app/AdminPanelSupabasePage/OPEN_EDIT_MODAL';
export const CLOSE_EDIT_MODAL = 'app/AdminPanelSupabasePage/CLOSE_EDIT_MODAL';
export const FETCH_SPACE_DETAILS_REQUEST = 'app/AdminPanelSupabasePage/FETCH_SPACE_DETAILS_REQUEST';
export const FETCH_SPACE_DETAILS_SUCCESS = 'app/AdminPanelSupabasePage/FETCH_SPACE_DETAILS_SUCCESS';
export const FETCH_SPACE_DETAILS_ERROR = 'app/AdminPanelSupabasePage/FETCH_SPACE_DETAILS_ERROR';
export const UPLOAD_DOCUMENT_REQUEST = 'app/AdminPanelSupabasePage/UPLOAD_DOCUMENT_REQUEST';
export const UPLOAD_DOCUMENT_SUCCESS = 'app/AdminPanelSupabasePage/UPLOAD_DOCUMENT_SUCCESS';
export const UPLOAD_DOCUMENT_ERROR = 'app/AdminPanelSupabasePage/UPLOAD_DOCUMENT_ERROR';
export const REQUEST_SPECIFIC_RULEBOOK = 'app/AdminPanelSupabasePage/REQUEST_SPECIFIC_RULEBOOK';
export const SUCCESS_SPECIFIC_RULEBOOK = 'app/AdminPanelSupabasePage/SUCCESS_SPECIFIC_RULEBOOK';
export const ERROR_SPECIFIC_RULEBOOK = 'app/AdminPanelSupabasePage/ERROR_SPECIFIC_RULEBOOK';
export const REQUEST_DELETE_RULEBOOK = 'app/AdminPanelSupabasePage/REQUEST_DELETE_RULEBOOK';
export const SUCCESS_DELETE_RULEBOOK = 'app/AdminPanelSupabasePage/SUCCESS_DELETE_RULEBOOK';
export const ERROR_DELETE_RULEBOOK = 'app/AdminPanelSupabasePage/ERROR_DELETE_RULEBOOK';

export const REQUEST_GENERAL_RULEBOOK = 'app/AdminPanelSupabasePage/REQUEST_GENERAL_RULEBOOK';
export const SUCCESS_GENERAL_RULEBOOK = 'app/AdminPanelSupabasePage/SUCCESS_GENERAL_RULEBOOK';
export const ERROR_GENERAL_RULEBOOK = 'app/AdminPanelSupabasePage/ERROR_GENERAL_RULEBOOK';

export const REQUEST_PRIMARY_RULEBOOK = 'app/AdminPanelSupabasePage/REQUEST_PRIMARY_RULEBOOK';
export const SUCCESS_PRIMARY_RULEBOOK = 'app/AdminPanelSupabasePage/SUCCESS_PRIMARY_RULEBOOK';
export const ERROR_PRIMARY_RULEBOOK = 'app/AdminPanelSupabasePage/ERROR_PRIMARY_RULEBOOK';

// ================ Reducer ================ //

const initialState = {
  fetchInProgress: false,
  fetchSpaceListError: null,
  spaceList: [],
  isEditModalOpen: false,
  selectedSpaceId: null,
  selectedSpaceDetails: null,
  fetchSpaceDetailsInProgress: false,
  fetchSpaceDetailsError: null,
  uploadDocumentInProgress: false,
  uploadDocumentError: null,
  specificRulebookInprogress: false,
  specificRulebookData: null,
  errorSpecificRulebook: null,
  deleteRulebookInprogress: false,
  deleteRulebookData: null,
  errorDeleteRulebook: null,

  generalRulebookInprogress: false,
  generalRulebookData: null,
  errorGeneralRulebook: null,

  primaryRulebookInprogress: false,
  primaryRulebookData: null,
  errorPrimaryRulebook: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_SPACE_LIST_REQUEST:
      return { ...state, fetchInProgress: true, fetchSpaceListError: null };
    case FETCH_SPACE_LIST_SUCCESS:
      return { ...state, fetchInProgress: false, spaceList: payload };
    case FETCH_SPACE_LIST_ERROR:
      return { ...state, fetchInProgress: false, fetchSpaceListError: payload };
    case OPEN_EDIT_MODAL:
      return {
        ...state,
        isEditModalOpen: true,
        selectedSpaceId: payload,
      };
    case CLOSE_EDIT_MODAL:
      return {
        ...state,
        isEditModalOpen: false,
        selectedSpaceId: null,
        selectedSpaceDetails: null,
        fetchSpaceDetailsError: null,
        uploadDocumentError: null,
      };
    case FETCH_SPACE_DETAILS_REQUEST:
      return {
        ...state,
        fetchSpaceDetailsInProgress: true,
        fetchSpaceDetailsError: null,
      };
    case FETCH_SPACE_DETAILS_SUCCESS:
      return {
        ...state,
        fetchSpaceDetailsInProgress: false,
        selectedSpaceDetails: payload,
      };
    case FETCH_SPACE_DETAILS_ERROR:
      return {
        ...state,
        fetchSpaceDetailsInProgress: false,
        fetchSpaceDetailsError: payload,
      };
    case UPLOAD_DOCUMENT_REQUEST:
      return {
        ...state,
        uploadDocumentInProgress: true,
        uploadDocumentError: null,
      };
    case UPLOAD_DOCUMENT_SUCCESS:
      return {
        ...state,
        uploadDocumentInProgress: false,
      };
    case UPLOAD_DOCUMENT_ERROR:
      return {
        ...state,
        uploadDocumentInProgress: false,
        uploadDocumentError: payload,
      };
    case REQUEST_SPECIFIC_RULEBOOK: 
      return{
        ...state,
        specificRulebookInprogress: true,
        specificRulebookData: null,
        errorSpecificRulebook: null,
      }
    case SUCCESS_SPECIFIC_RULEBOOK:
        return{
          ...state,
          specificRulebookInprogress: false,
          specificRulebookData: payload.data,
        }
    case ERROR_SPECIFIC_RULEBOOK:
      return{
        ...state,
        specificRulebookInprogress: false,
        errorSpecificRulebook: payload.error,
      }
    case REQUEST_DELETE_RULEBOOK: 
      return{
        ...state,
        deleteRulebookInprogress: true,
        deleteRulebookData: null,
        errorDeleteRulebook: null,
      }
    case SUCCESS_DELETE_RULEBOOK:
        return{
          ...state,
          deleteRulebookInprogress: false,
          deleteRulebookData: payload.data,
          specificRulebookData: null
        }
    case ERROR_DELETE_RULEBOOK:
      return{
        ...state,
        deleteRulebookInprogress: false,
        errorDeleteRulebook: payload.error,
      }

    case REQUEST_GENERAL_RULEBOOK:
      return {
        ...state,
        generalRulebookInprogress: true,
        generalRulebookData: null,
        errorGeneralRulebook: null,
      }
    case SUCCESS_GENERAL_RULEBOOK:
      return {
        ...state,
        generalRulebookInprogress: false,
        generalRulebookData: payload.data,
        errorGeneralRulebook: null,
      }
    case ERROR_GENERAL_RULEBOOK:
      return {
        ...state,
        generalRulebookInprogress: false,
        errorGeneralRulebook: payload.error,
        generalRulebookData: null,
      }

    case REQUEST_PRIMARY_RULEBOOK:
      return {
        ...state,
        primaryRulebookInprogress: true,
        primaryRulebookData: null,
        errorPrimaryRulebook: null,
      }
    case SUCCESS_PRIMARY_RULEBOOK:
      return {
        ...state,
        primaryRulebookInprogress: false,
        primaryRulebookData: payload.data,
        errorPrimaryRulebook: null,
      }
    case ERROR_PRIMARY_RULEBOOK:
      return {
        ...state,
        primaryRulebookInprogress: false,
        errorPrimaryRulebook: payload.error,
        primaryRulebookData: null,
      }

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const requestSpecificRulebook = () => ({
  type: REQUEST_SPECIFIC_RULEBOOK
})

export const successSpecificRulebook = (data) => ({
  type: SUCCESS_SPECIFIC_RULEBOOK,
  payload: {data}
})

export const errorSpecificRulebook = (error) => ({
  type: ERROR_SPECIFIC_RULEBOOK,
  payload: {error}
})
export const requestDeleteRulebook = () => ({
  type: REQUEST_DELETE_RULEBOOK
})

export const successDeleteRulebook = (data) => ({
  type: SUCCESS_DELETE_RULEBOOK,
  payload: {data}
})

export const errorDeleteRulebook = (error) => ({
  type: ERROR_DELETE_RULEBOOK,
  payload: {error}
})

export const fetchSpaceListRequest = () => ({ type: FETCH_SPACE_LIST_REQUEST });
export const fetchSpaceListSuccess = spaces => ({
  type: FETCH_SPACE_LIST_SUCCESS,
  payload: spaces,
});
export const fetchSpaceListError = error => ({
  type: FETCH_SPACE_LIST_ERROR,
  payload: error,
});

export const openEditModal = spaceId => ({
  type: OPEN_EDIT_MODAL,
  payload: spaceId,
});

export const closeEditModal = () => ({
  type: CLOSE_EDIT_MODAL,
});

export const fetchSpaceDetailsRequest = () => ({
  type: FETCH_SPACE_DETAILS_REQUEST,
});

export const fetchSpaceDetailsSuccess = details => ({
  type: FETCH_SPACE_DETAILS_SUCCESS,
  payload: details,
});

export const fetchSpaceDetailsError = error => ({
  type: FETCH_SPACE_DETAILS_ERROR,
  payload: error,
});

export const uploadDocumentRequest = () => ({
  type: UPLOAD_DOCUMENT_REQUEST,
});

export const uploadDocumentSuccess = () => ({
  type: UPLOAD_DOCUMENT_SUCCESS,
});

export const uploadDocumentError = error => ({
  type: UPLOAD_DOCUMENT_ERROR,
  payload: error,
});

export const requestGeneralRulebook = () => ({
  type: REQUEST_GENERAL_RULEBOOK
});

export const successGeneralRulebook = (data) => ({
  type: SUCCESS_GENERAL_RULEBOOK,
  payload: { data }
});

export const errorGeneralRulebook = (error) => ({
  type: ERROR_GENERAL_RULEBOOK,
  payload: { error }
});

export const requestPrimaryRulebook = () => ({
  type: REQUEST_PRIMARY_RULEBOOK
});

export const successPrimaryRulebook = (data) => ({
  type: SUCCESS_PRIMARY_RULEBOOK,
  payload: { data }
});

export const errorPrimaryRulebook = (error) => ({
  type: ERROR_PRIMARY_RULEBOOK,
  payload: { error }
});

// ================ Thunks ================ //

export const fetchSpaceList = (params) => (dispatch, getState, sdk) => {
  dispatch(fetchSpaceListRequest());
  const {page = 1, per_page = 10} = params;
  return fetchSpaceListApiV2({per_page, page})
    .then(response => {
      dispatch(fetchSpaceListSuccess(response));
      return response;
    })
    .catch(e => {
      console.log('e', e);
      dispatch(fetchSpaceListError("Failed to fetch space list"));
      throw e;
    });
};

export const getGeneralGroupRulebook = (params) => async (dispatch, getState, sdk) => {
  try {
    dispatch(requestGeneralRulebook())
    const response = await getSpecificUserGPTS({ ...params })
    dispatch(successGeneralRulebook(response?.gpts))
    return response?.gpts ;
  } catch (error) {
    dispatch(errorGeneralRulebook(error))
  }
};

export const getPrimaryRulebook = (params) => async (dispatch, getState, sdk) => {
  try {
    dispatch(requestPrimaryRulebook())
    const response = await getSpecificUserGPTS({ ...params })
    console.log(response);

    dispatch(successPrimaryRulebook(response?.gpts))
    return response?.gpts;
  } catch (error) {
    dispatch(errorPrimaryRulebook(error))
  }
};

export const loadData = params => (dispatch, getState) => {
  return Promise.all([dispatch(fetchCurrentUser({}))])
    .then(async response => {
      const currentUser = getState().user.currentUser;
      if (currentUser?.attributes?.profile?.privateData?.isSupabaseAdmin) {
        dispatch(fetchSpaceList({ }));
        dispatch(getGeneralGroupRulebook({ is_general: true }));
      }
      return response;
    })
    .catch(e => {
      throw e;
    });
};

export const fetchSpaceDetails = spaceId => (dispatch, getState, sdk) => {
  dispatch(fetchSpaceDetailsRequest());
  return fetchSpaceList(spaceId)
    .then(response => {
      dispatch(fetchSpaceDetailsSuccess(response.data));
      return response;
    })
    .catch(e => {
      dispatch(fetchSpaceDetailsError(e.message));
      throw e;
    });
};

export const addRulebookDocument = (formData,editRulebook) => async (dispatch, getState, sdk) => {
  try {
    dispatch(uploadDocumentRequest());

    const response = await axios.post(
      editRulebook ?
        `${process.env.REACT_APP_SERVER_MARKETPLACE_ROOT_URL}/api/update-rule-book`
        : `${process.env.REACT_APP_SERVER_MARKETPLACE_ROOT_URL}/api/add-rule-book`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${process.env.SUPABASE_SERVICE_ROLE_KEY}`, // Use service key for admin access
        },
      }
    );

    dispatch(getSpecificGroupRulebook({ id: formData.get('group_id') }));
    dispatch(getGeneralGroupRulebook({ is_general: true }))
    dispatch(uploadDocumentSuccess());
    return response;
  } catch (error) {
    dispatch(uploadDocumentError(error));
  }
};

export const getSpecificGroupRulebook = (params) => async (dispatch, getState, sdk) => {
  try {
    const {id:group_id} = params ?? {} 
    dispatch(requestSpecificRulebook())
    const response = await getAllRulebooks({ group_id })
    dispatch(successSpecificRulebook(response?.gpts))
    return response?.gpts
  } catch (error) {
    dispatch(errorSpecificRulebook(error))
  }
}

export const deleteSpecificGroupRulebook = params => async (dispatch, getState, sdk) => {
  try {
    const { file_id, file_name, group_name , rulebook_name,id, logo_id} = params ?? {};
    dispatch(requestDeleteRulebook());
    const response = await deleteRulebookApi({ file_id, file_name, group_name, rulebook_name, logo_id });
    dispatch(getSpecificGroupRulebook({ id })) //group id
    dispatch(successDeleteRulebook(response));
    return response;
  } catch (error) {
    dispatch(errorDeleteRulebook(error));
  }
};

export const deleteSpecificGroupRulebookFile = params => async (dispatch, getState, sdk) => {
  try {
    const { file_id, id } = params ?? {};
    dispatch(requestDeleteRulebook());
    const response = await deleteRuleBookFile({ file_id });
    dispatch(getSpecificGroupRulebook({ id })) //group id
    dispatch(successDeleteRulebook(response));
    return response;
  } catch (error) {
    dispatch(errorDeleteRulebook(error));
  }
};